import format from '_shared_/plugins/format';
import { compareTwoDates, shiftDate } from '_shared_/utils/utils';

const getters = {
  getReturnsAtNav: state => state.returnsAtNav
};

function getAgeOfFund(InceptionDate) {
  const todayDate = new Date().getFullYear();
  const inceptionDate = new Date(InceptionDate).getFullYear();
  return todayDate - inceptionDate;
}
const mutations = {
  SET_RETURNS_AT_NAV(state, payload) {
    const useCumulative = compareTwoDates(shiftDate(new Date(payload.InceptionDate), 1, 'y'), payload.MonthlyAsOfDate) >= 0;		
    const isInception1yrOrLess = compareTwoDates(payload.InceptionDate, shiftDate(new Date(), -1, 'y')) >= 0;
    const isInceptionLessThan5yr = compareTwoDates(payload.InceptionDate, shiftDate(new Date(), -5, 'y')) > 0;
    const isInceptionLessThan10yr = compareTwoDates(payload.InceptionDate, shiftDate(new Date(), -10, 'y')) > 0;
    let NavLife = '--';
    if (useCumulative && typeof payload.cumulativeNAVLifetime === 'number') NavLife = format.formatHelpers.rawPercent(payload.cumulativeNAVLifetime, 2);
    if (!useCumulative && typeof payload.avgAnnualNAVLifetime === 'number') NavLife = format.formatHelpers.rawPercent(payload.avgAnnualNAVLifetime, 2);
    let Nav1yr = payload.Nav1Yr && format.formatHelpers.rawPercent(payload.Nav1Yr, 2) || '--';
    if (isInception1yrOrLess) Nav1yr = 'N/A';
    let Nav5yr = payload.Nav5yr && format.formatHelpers.rawPercent(payload.Nav5yr, 2) || '--';
    if (isInceptionLessThan5yr) Nav5yr = 'N/A';
    let Nav10yr = payload.Nav10yr && format.formatHelpers.rawPercent(payload.Nav10yr, 2) || '--';
    if (isInceptionLessThan10yr) Nav10yr = 'N/A';

    state.returnsAtNav = {
      Nav1yr: {
        data: Nav1yr,
        label: '1-year return'
      },
      Nav5yr: {
        data: Nav5yr,
        label: '5-year return'
      },
      Nav10yr: {
        data: Nav10yr,
        label: '10-year return'
      },
      NavLife: {
        data: NavLife,
        label: `Lifetime Return <br> (${payload.InceptionDate || '--'})`
      },
      Sec30DayYield: {
        data: payload.Sec30DayYield && format.formatHelpers.rawPercent(payload.Sec30DayYield, 2) || '--',
        excelLabel: '30-Day SEC Yield',
        asOfDate: `Yield as of ${payload.Sec30DayYieldAsOfDate || '--'} (updated monthly).`,
        label: '30-Day SEC Yield'
      },
      AsOfDate: `Returns as of ${payload.MonthlyAsOfDate || '--'} (updated monthly). Yield as of ${payload.Sec30DayYieldAsOfDate || '--'} (updated monthly).`,
      AgeOfFund: payload.InceptionDate && getAgeOfFund(payload.InceptionDate)
    };
  }
};


const state = {
  returnsAtNav: null
};

export default {
  state,
  getters,
  mutations
};
